import { useState, useEffect } from 'react';

const Menu = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showFood, setShowFood] = useState(false);
  const [showDrinks, setShowDrinks] = useState(false);
  const [showTakeaway, setShowTakeaway] = useState(false);
  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  return (
    <div className={`${isVisible ? 'page-transition-active' : 'page-transition'}`}>
      <div className="min-h-screen bg-[#EFEAE7] py-4 sm:py-6 md:py-8 relative overflow-hidden">
        {/* Corner Images - Responsive sizes */}
        <div className="absolute inset-0 pointer-events-none">
          <img 
            src="/phoart.png"
            alt="Vietnamese pho dish" 
            className="absolute top-0 right-0 w-20 sm:w-48 lg:w-72 h-20 sm:h-48 lg:h-72 object-cover rounded-lg -mt-2 sm:-mt-4 -mr-2 sm:-mr-4 image-hover"
          />
          <img 
            src="/phoart3.png"
            alt="Vietnamese pho close-up" 
            className="absolute top-1/3 left-0 w-24 sm:w-48 lg:w-72 h-24 sm:h-48 lg:h-72 object-cover rounded-lg -ml-2 sm:-ml-4 image-hover"
          />
          <img 
            src="/phoart2.png"
            alt="Vietnamese tea" 
            className="absolute bottom-1/4 -right-4 sm:-right-8 w-24 sm:w-48 lg:w-72 h-24 sm:h-48 lg:h-72 object-cover rounded-lg image-hover"
          />
        </div>

        <div className="container mx-auto px-4 sm:px-8 md:px-16 max-w-7xl text-center relative z-10">
          {/* The Menu Section */}
          <div className="grid grid-cols-1 gap-8 sm:gap-12 mb-12 sm:mb-16 md:mb-20 items-center pt-2 sm:pt-4 md:pt-6">
            {/* Content */}
            <div className="flex flex-col items-center text-center">
              <h2 className="mb-4 sm:mb-6">
                <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-2xl sm:text-3xl md:text-4xl font-bold">WELCOME TO</span>
                <span className="font-['Playfair_Display_SC'] text-black text-2xl sm:text-3xl md:text-4xl font-bold ml-2">LOTUS STORY</span>
              </h2>
              <p className="font-['Outfit'] italic text-sm sm:text-base md:text-lg leading-relaxed mb-3 max-w-2xl px-4 sm:px-0">
                Where cuisine becomes storytelling
              </p>
              <div className="font-['Outfit'] text-sm sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8 max-w-2xl px-4 sm:px-0 space-y-4">
                <p>
                  At Lotus Story, every dish begins with a memory — <em>a whisper of the past, a fragrance of home, a moment that lingers</em>. Rooted in the rich culinary heritage of Vietnam and delicately elevated with modern inspiration, our menu invites you on a journey through flavors, textures, and time.
                </p>
                <p>
                  Here, street food traditions meet refined craftsmanship. Humble ingredients become elegant expressions. And every plate is a chapter — of culture, of comfort, and of creative reinterpretation.
                </p>
                <p>
                  Whether it's a bold bowl of Pho Bo Tai Lan kissed by flame, or a delicate flan laced with ginger, we hope each bite brings warmth, wonder, and a deeper connection to the story behind the lotus.
                </p>
                <p className="italic">
                  Let this be more than a meal.<br />
                  Let it be a story you remember.
                </p>
              </div>
              <button 
                onClick={() => setShowMenu(!showMenu)}
                className="w-full sm:w-auto px-8 sm:px-12 py-2 border border-black rounded-sm font-['Outfit'] hover:bg-black hover:text-white transition-colors button-hover max-w-xs"
              >
                View Our Signature Dish
              </button>

              {/* Menu Image */}
              {showMenu && (
                <div className="w-full max-w-4xl mt-8 sm:mt-12 px-4 sm:px-8 transition-all duration-500 ease-out transform opacity-100 scale-100 animate-fadeIn">
                  <img
                    src="/page2.jpg"
                    alt="Restaurant Menu"
                    className="w-full h-auto rounded-lg shadow-lg"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Divider */}
          <div className="w-1/2 md:w-1/3 lg:w-1/4 mx-auto h-px bg-[#4F6632] opacity-50 mb-12 sm:mb-16 md:mb-20"></div>

          {/* Main Dish Section */}
          <div className="grid grid-cols-1 gap-6 sm:gap-8 items-center">
            {/* Content */}
            <div className="flex flex-col items-center text-center">
              <h2 className="mb-4 sm:mb-6">
                <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-2xl sm:text-3xl md:text-4xl font-bold">THE</span>
                <span className="font-['Playfair_Display_SC'] text-black text-2xl sm:text-3xl md:text-4xl font-bold ml-2">DINNER MENU</span>
              </h2>
              <p className="font-['Outfit'] text-sm sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8 max-w-xl px-4 sm:px-0">
                Our menu is thoughtfully curated to showcase the diversity of Vietnamese flavors while incorporating contemporary 
                Australian influences. We offer a variety of tasting menus, each inspired by Vietnam's unique regions, seasonal festivals, 
                and traditional folk tales.
              </p>
              <button 
                onClick={() => setShowFood(!showFood)}
                className="w-full sm:w-auto px-8 sm:px-12 py-2 border border-black rounded-sm font-['Outfit'] hover:bg-black hover:text-white transition-colors button-hover max-w-xs mb-2 sm:mb-4"
              >
                View Food Menu
              </button>

              {/* Dinner Menu Images */}
              {showFood && (
                <div className="w-full max-w-4xl mt-8 sm:mt-12 px-4 sm:px-8 mb-2 sm:mb-4 transition-all duration-500 ease-out transform opacity-100 scale-100 animate-fadeIn flex flex-col gap-6">
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((num) => (
                    <img
                      key={num}
                      src={`/fullmenu24aug/fullmenu24aug-${String(num).padStart(2, '0')}.png`}
                      alt={`Dinner Menu Page ${num}`}
                      className="w-full h-auto rounded-lg shadow-lg"
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
          <br />
          <br />
          <br />
        

          {/* Divider */}
          <div className="w-1/2 md:w-1/3 lg:w-1/4 mx-auto h-px bg-[#4F6632] opacity-50 mb-12 sm:mb-16 md:mb-20"></div>

{/* Beverage List Section */}
<div className="grid grid-cols-1 gap-6 sm:gap-8 items-center">
  {/* Content */}
  <div className="flex flex-col items-center text-center">
    <h2 className="mb-4 sm:mb-6">
      <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-2xl sm:text-3xl md:text-4xl font-bold">THE</span>
      <span className="font-['Playfair_Display_SC'] text-black text-2xl sm:text-3xl md:text-4xl font-bold ml-2">DRINK MENU</span>
    </h2>
    <p className="font-['Outfit'] text-sm sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8 max-w-xl px-4 sm:px-0">
    Our drink menu is carefully crafted to highlight the rich variety of Vietnamese flavors, blended with modern Australian touches. Each tasting menu draws inspiration from different regions of Vietnam, seasonal celebrations, and timeless folk stories.

        
    </p>
    <button 
      onClick={() => setShowDrinks(!showDrinks)}
      className="w-full sm:w-auto px-8 sm:px-12 py-2 border border-black rounded-sm font-['Outfit'] hover:bg-black hover:text-white transition-colors button-hover max-w-xs mb-2 sm:mb-4"
    >
      View Drink Menu
    </button>

    {/* Beverage Menu Images */}
    {showDrinks && (
      <div className="w-full max-w-4xl mt-8 sm:mt-12 px-4 sm:px-8 mb-2 sm:mb-4 transition-all duration-500 ease-out transform opacity-100 scale-100 animate-fadeIn flex flex-col gap-6">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
          <img
            key={num}
            src={`/beveragemenuaug/beveragemenuaug-${num}.jpg`}
            alt={`Beverage Menu Page ${num}`}
            className="w-full h-auto rounded-lg shadow-lg"
          />
        ))}
      </div>
    )} 
  </div>
</div>

<br />
          <br />
          <br />
        

          {/* Divider */}
          <div className="w-1/2 md:w-1/3 lg:w-1/4 mx-auto h-px bg-[#4F6632] opacity-50 mb-12 sm:mb-16 md:mb-20"></div>

{/* Takeaway Menu Section */}
<div className="grid grid-cols-1 gap-6 sm:gap-8 items-center">
  {/* Content */}
  <div className="flex flex-col items-center text-center">
    <h2 className="mb-4 sm:mb-6">
      <span className="font-['Playfair_Display_SC'] text-[#4F6632] text-2xl sm:text-3xl md:text-4xl font-bold">THE</span>
      <span className="font-['Playfair_Display_SC'] text-black text-2xl sm:text-3xl md:text-4xl font-bold ml-2">LUNCH MENU</span>
    </h2>
    <p className="font-['Outfit'] text-sm sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8 max-w-xl px-4 sm:px-0">
    Our lunch menu brings the vibrant essence of Vietnamese cuisine to your home, combining authentic regional dishes with a fresh, modern twist.
    Designed for convenience without compromising on flavor, each item reflects the spirit of Vietnam's street food culture, seasonal ingredients, and cherished family recipes.
    This lunch menu is available for takeaway only during lunchtime.
    </p>
    <button 
      onClick={() => setShowTakeaway(!showTakeaway)}
      className="w-full sm:w-auto px-8 sm:px-12 py-2 border border-black rounded-sm font-['Outfit'] hover:bg-black hover:text-white transition-colors button-hover max-w-xs mb-2 sm:mb-4"
    >
      View Takeaway Menu
    </button>

    {/* Lunch Menu Image */}
    {showTakeaway && (
      <div className="w-full max-w-4xl mt-8 sm:mt-12 px-4 sm:px-8 mb-2 sm:mb-4 transition-all duration-500 ease-out transform opacity-100 scale-100 animate-fadeIn flex flex-col gap-6">
        <img
          src="/lunch2026.jpg"
          alt="Lunch Menu"
          className="w-full h-auto rounded-lg shadow-lg"
        />
      </div>
    )} 
  </div>
</div>

          
        </div>
      </div>
    </div>
  );
};

export default Menu; 